import { __awaiter, __generator, __read, __values } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react'; /**${comma}*/
import { GuideBox, DropList, VerifyUtil } from "@midasit-dev/moaui"; /**${comma}*/
function getNestedProperty(obj, path) {
    var e_1, _a;
    // 점과 대괄호를 사용하여 경로를 나눕니다. 대괄호 내의 내용(정수 인덱스)도 처리합니다.
    var keys = path.replace(/\[(\w+)\]/g, '.$1').split('.'); // 대괄호를 점 표기법으로 변환
    var currentObject = obj;
    try {
        for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
            var key = keys_1_1.value;
            if (key in currentObject) { // key가 현재 객체에 존재하는지 확인
                currentObject = currentObject[key];
            }
            else {
                return undefined;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return currentObject;
}
var AutoDropList = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 300 : _b, /**${props-separator}*/ _c = _a.height, /**${props-separator}*/ height = _c === void 0 ? 30 : _c, /**${props-separator}*/ _d = _a.dropListwidth, /**${props-separator}*/ dropListwidth = _d === void 0 ? 150 : _d, /**${props-separator}*/ _e = _a.defaultValue, /**${props-separator}*/ defaultValue = _e === void 0 ? 1 : _e, /**${props-separator}*/ _f = _a.value, /**${props-separator}*/ value = _f === void 0 ? undefined : _f, /**${props-separator}*/ _g = _a.onChange, /**${props-separator}*/ onChange = _g === void 0 ? undefined : _g, /**${props-separator}*/ _h = _a.show, /**${props-separator}*/ show = _h === void 0 ? false : _h, /**${props-separator}*/ _j = _a.db, /**${props-separator}*/ db = _j === void 0 ? "node" : _j, /**${props-separator}*/ _k = _a.filter, /**${props-separator}*/ filter = _k === void 0 ? "X" : _k, /**${props-separator}*/ _l = _a.textFormat, /**${props-separator}*/ textFormat = _l === void 0 ? undefined : _l, /**${props-separator}*/ _m = _a.valueFormat, /**${props-separator}*/ valueFormat = _m === void 0 ? undefined : _m;
    var _o = __read(React.useState(defaultValue), 2), valueLocal = _o[0], setValueLocal = _o[1];
    var _p = __read(React.useState([["NONE", 1]]), 2), items = _p[0], setItems = _p[1];
    var _q = __read(React.useState(false), 2), isLoading = _q[0], setLoading = _q[1];
    var onChangeLocal = React.useCallback(function (e) {
        setValueLocal(e.target.value);
    }, []);
    var defaultTextFormat = React.useCallback(function (item) { return String("".concat(item[0], " : ").concat(item[1]) || "".concat(item[0], " : NONE")); }, []);
    var defaultValueFormat = React.useCallback(function (item) { return Number(item[0]); }, []);
    var fetchData = React.useCallback(function (db, filter, textFormat, valueFormat) { return __awaiter(void 0, void 0, void 0, function () {
        var mapiKey, baseUrl, res, data, target;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    mapiKey = VerifyUtil.getMapiKey();
                    if (mapiKey === "") {
                        throw Error("mapiKey is not found");
                    }
                    return [4 /*yield*/, VerifyUtil.getBaseUrlAsync()];
                case 1:
                    baseUrl = _a.sent();
                    if (baseUrl.includes("undefined")) {
                        throw Error("product not found");
                    }
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/db/").concat(db, "/"), {
                            headers: {
                                'MAPI-Key': mapiKey,
                            }
                        }).catch(function () {
                            throw Error("fetch error");
                        })];
                case 2:
                    res = _a.sent();
                    if (!res.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, res.json()];
                case 3:
                    data = _a.sent();
                    target = Object.entries(data[db.toUpperCase()]);
                    return [2 /*return*/, target.map(function (item) {
                            var newItem = [item[0], getNestedProperty(item[1], filter)];
                            return [textFormat(newItem), valueFormat(newItem)];
                        })];
                case 4: throw Error("");
            }
        });
    }); }, []);
    React.useEffect(function () {
        setLoading(true);
        fetchData(db, filter, textFormat || defaultTextFormat, valueFormat || defaultValueFormat)
            .then(function (data) {
            setItems(data);
        }).catch(function () {
            setItems([["NONE", 1]]);
        }).finally(function () {
            setLoading(false);
        });
    }, [db, filter, fetchData, textFormat, defaultTextFormat, valueFormat, defaultValueFormat]);
    return (_jsx(GuideBox, { show: show, width: width, height: height, row: true, horSpaceBetween: true, children: _jsx(DropList, { itemList: items, width: dropListwidth, defaultValue: defaultValue, value: value || valueLocal, onChange: onChange || onChangeLocal, disabled: isLoading }) }));
}; /**${comma}*/
var SampleProps = {
    width: 300,
    height: 30,
    dropListwidth: 150,
    defaultValue: 1,
    value: undefined,
    onChange: undefined,
    show: false,
    db: "node",
    filter: "X",
    textFormat: function (item) { return String("".concat(item[0], " : ").concat(item[1]) || "".concat(item[0], " : No Value")); },
    valueFormat: function (item) { return Number(item[0]); },
}; /**${comma}*/
export default AutoDropList;
export { SampleProps as AutoDropListSample, };
